import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { AGENCY_INFO } from '../data/content';

export default function FloatingWhatsApp() {
  const [showTooltip, setShowTooltip] = useState(true);

  const whatsappUrl = `https://wa.me/${AGENCY_INFO.whatsappClean || '56978373379'}?text=${encodeURIComponent(
    'Hola Épica Comunicaciones, me gustaría solicitar información sobre sus servicios o agendar una reunión estratégica.'
  )}`;

  return (
    <div className="fixed bottom-8 right-8 z-40 hidden md:flex flex-col items-end gap-2 group">
      {/* Optional Tooltip Bubble */}
      {showTooltip && (
        <div className="relative bg-slate-900/95 backdrop-blur-md text-white text-xs py-2.5 px-4 rounded-2xl shadow-2xl border border-slate-700/80 flex items-center gap-3 animate-bounce">
          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            <span className="font-semibold text-slate-100">¿Conversamos por WhatsApp?</span>
          </div>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowTooltip(false);
            }}
            className="text-slate-400 hover:text-white transition-colors p-0.5 rounded-full hover:bg-slate-800"
            title="Cerrar aviso"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          {/* Arrow pointing down-right */}
          <div className="absolute -bottom-1.5 right-6 w-3 h-3 bg-slate-900 border-r border-b border-slate-700 transform rotate-45"></div>
        </div>
      )}

      {/* Main Floating Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white shadow-xl shadow-emerald-500/30 transition-all duration-300 hover:scale-110 active:scale-95 group-hover:shadow-emerald-500/50"
        aria-label="Contactar por WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-25"></span>
        <MessageCircle className="w-7 h-7 text-white fill-white/10" />
      </a>
    </div>
  );
}
